import React from "react";
import { useState } from "react";
import './scss/Achorscroll.scss'

const AnchorScroll = () => {
  const [one, setOne] = useState(true);
  const [two, setTwo] = useState(true);
  const [three, setThree] = useState(true);
  const handleClick = (id) => {
    switch (id) {
      case "1":
        setOne(true);
        setTwo(true);
        setThree(true);
        break;
      case "2":
        setOne(false);
        setTwo(true);
        setThree(true);
        break;
      case "3":
        setOne(false);
        setTwo(false);
        setThree(true);
        break;
      default:
        break;
    }
  };
  return (
    <div id="AnchorScroll">
      <a
        onClick={(e) => handleClick(e.target.id)}
        style={{ fontSize: "30px" }}
        className="common"
        id="1"
        href="#one"
      >
        {one ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            id="1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              id="1"
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            id="1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              id="1"
              d="M5 10l7-7m0 0l7 7m-7-7v18"
            />
          </svg>
        )}
      </a>
      <a
        onClick={(e) => handleClick(e.target.id)}
        style={{ fontSize: "30px" }}
        className="common"
        id="2"
        href="#tow"
      >
        {two ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            id="2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              id="2"
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            id="2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              id="2"
              d="M5 10l7-7m0 0l7 7m-7-7v18"
            />
          </svg>
        )}
      </a>
      <a
        onClick={(e) => handleClick(e.target.id)}
        style={{ fontSize: "30px" }}
        className="common"
        id="3"
        href="#three"
      >
        {three ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            id="3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              id="3"
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            id="3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              id="3"
              d="M5 10l7-7m0 0l7 7m-7-7v18"
            />
          </svg>
        )}
      </a>
    </div>
  );
};

export default AnchorScroll;
